<template>
  <section>
    <v-container fluid>
      <v-row class="justify-between align-center">
        <v-col cols="auto">
          <v-btn class="accent shadow-4 px-8" large rounded @click="isFormOpen = true">
            Añadir Cita
          </v-btn>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="openImportData" class="ml-2" v-bind="attrs" v-on="on" color="info" small rounded fab>
                <v-icon>
                  mdi-upload
                </v-icon>
              </v-btn>
            </template>
            <span>Importar</span>
          </v-tooltip>
        </v-col>

        <v-col cols="auto" class="ml-auto">
          <v-text-field
            filled
            rounded
            dense
            v-model="search"
            append-icon="mdi-magnify"
            readonly
            @click="isSearchOpen = true"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="shadow-1">
      <v-data-table
        :headers="headers"
        :items="tableList"
        :options.sync="tableOptions"
        :loading="isLoading"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100],
        }"
      >
        <template v-slot:[`item.specialty`]="{ item }">
          {{ item.specialty ? item.specialty.name : "" }}
        </template>
        <template v-slot:[`item.responsible`]="{ item }">
          {{ item.responsible ? `${item.responsible.name} ${item.responsible.last_name}` : "" }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip color="transparent" small>
            <v-icon left small :color="getStatusColor(item.status)">mdi-radiobox-marked</v-icon>
            {{ item.status | statusName }}
          </v-chip>
        </template>
        <template v-slot:[`item.send_type`]="{ item }">
          <v-chip
            :class="item.send_type === 2 ? 'white--text' : ''"
            :color="item.send_type === 1 ? 'gray' : 'green'"
            small
          >
            {{ item.send_type === 1 ? "SMS" : "WhatsApp" }}
          </v-chip>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-hover v-slot:default="{ hover }">
                <v-btn
                  v-on="on"
                  text
                  icon
                  :color="hover ? 'accent' : 'blue-grey'"
                  @click.stop="handleClickMessage(item)"
                >
                  <v-icon>mdi-email-fast-outline</v-icon>
                </v-btn>
              </v-hover>
            </template>
            <span>Enviar mensaje</span>
          </v-tooltip>
          <v-hover v-slot:default="{ hover }">
            <v-btn text icon :color="hover ? 'accent' : 'blue-grey'" @click.stop="handleClickEdit(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn text icon :color="hover ? 'error' : 'blue-grey'" @click.stop="handleClickDelete(item)">
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-hover>
        </template>
      </v-data-table>
    </v-card>

    <appointment-dialog :open="isFormOpen" :editData="itemToEdit" @dialog:close="closeForm"></appointment-dialog>
    <core-delete-dialog
      :open="isDeleteOpen"
      :onDelete="deleteItem"
      title="cita"
      @dialog:close="closeDeleteDialog"
    ></core-delete-dialog>
    <search-dialog :open="isSearchOpen" @dialog:close="closeSearchDialog" :hasFiltersApplied="!!search"></search-dialog>
    <import-dialog
      v-if="isImportOpen"
      :isOpenDialog="isImportOpen"
      :campaignId="id"
      @dialog:close="closeImportData"
    ></import-dialog>
  </section>
</template>

<script>
import AppointmentDialog from "@/components/Appointments/AppointmentDialog.vue";
import SearchDialog from "@/components/Appointments/SearchDialog.vue";
import ImportDialog from "@/components/Appointments/ImportDialog.vue";
import { PbxHttpClient } from "@/services/httpclient";
import CoreDeleteDialog from "@/components/Utils/CoreDeleteDialog.vue";
import { stringifyObject } from "@/components/Utils/stringHelpers";

export default {
  components: { AppointmentDialog, CoreDeleteDialog, SearchDialog, ImportDialog },
  data() {
    return {
      isLoading: false,
      isFormOpen: false,
      isImportOpen: false,
      isSearchOpen: false,
      isDeleteOpen: false,
      search: "",
      searchParams: {},
      headers: [
        {
          text: "Cita",
          value: "template.title",
          class: "primary--text",
          width: "15%",
          align: "left",
        },
        {
          text: "Especialidad",
          value: "specialty",
          class: "primary--text",
          width: "15%",
          align: "left",
        },
        {
          text: "Responsable",
          value: "responsible",
          class: "primary--text",
          width: "15%",
          align: "left",
        },
        {
          text: "Fecha",
          value: "appointment_date",
          class: "primary--text",
          width: "15%",
        },
        {
          text: "Observaciones",
          value: "observations",
          class: "primary--text",
          width: "15%",
        },
        {
          text: "Estatus",
          value: "status",
          class: "primary--text",
          width: "10%",
        },
        {
          text: "Tipo de mensaje",
          value: "send_type",
          class: "primary--text",
          align: "center",
          width: "10%",
        },
        {
          text: "Mensajes enviados",
          value: "send_count",
          class: "primary--text",
          width: "10%",
        },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "10%",
          align: "right",
          sortable: false,
        },
      ],
      tableOptions: {
        page: 1,
        itemsPerPage: 15,
      },
      tableList: [],
      templateList: [],
      totalItems: 0,
      itemToEdit: null,
      targetStatus: "",
    };
  },

  watch: {
    tableOptions: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  filters: {
    statusName(val) {
      if (val === "canceled") return "Cancelada";
      if (val === "confirmed") return "Confirmada";
      return "Pendiente";
    },
  },

  methods: {
    async getData() {
      this.isLoading = true;
      try {
        const { sortDesc, page, itemsPerPage } = this.tableOptions;

        const { data } = await PbxHttpClient.get("/module_appointment/appointments", {
          params: { page, itemPerPage: itemsPerPage, prioritySort: sortDesc, ...this.searchParams },
        });
        this.tableList = data.data;
        this.totalItems = data.total;
      } catch (error) {
        console.log(error);
      }
      this.isLoading = false;
    },

    closeForm(item = false) {
      this.isFormOpen = false;
      if (item) {
        if (item.template) {
          if (this.itemToEdit) this.tableList = this.tableList.map((el) => (el.id === item.id ? item : el));
          else this.tableList = [...this.tableList, item];
        } else {
          this.getData();
        }
      }
      this.itemToEdit = null;
    },
    closeDeleteDialog() {
      this.itemToEdit = null;
      this.isDeleteOpen = false;
    },
    closeStatusDialog() {
      this.targetStatus = "";
      this.isStatusOpen = false;
    },
    handleClickEdit(item) {
      this.itemToEdit = item;
      this.isFormOpen = true;
    },
    handleClickDelete(item) {
      this.itemToEdit = item;
      this.isDeleteOpen = true;
    },
    async handleClickMessage(item) {
      try {
        await PbxHttpClient.post(`/module_appointment/appointments/${item.id}/send-message`);
        this.$snotify.success(`Mensaje enviado con exito`, "¡Hecho!");
      } catch (error) {
        this.$snotify.error("Hubo un error enviando el mensaje", "¡Error!");
        console.log("error sending message", error);
        return false;
      }
    },

    async deleteItem() {
      try {
        await PbxHttpClient.delete(`/module_appointment/appointments/${this.itemToEdit.id}`);
        this.$snotify.success("Cita eliminada con exito", "¡Hecho!");
        this.tableList = this.tableList.filter((el) => el.id !== this.itemToEdit.id);
        return true;
      } catch (error) {
        this.$snotify.error("Hubo un error eliminando la Cita", "¡Error!");
        console.log("error deleting appointment", error);
        return false;
      }
    },

    closeSearchDialog(params) {
      debugger;
      this.isSearchOpen = false;

      if (!params) return;

      const { searchParams, prettySearchParams } = params;
      this.search = stringifyObject(prettySearchParams);
      this.searchParams = searchParams;
      this.getData();
    },

    openImportData() {
      this.isImportOpen = true;
    },

    closeImportData(forceReload) {
      this.isImportOpen = false;
      if (forceReload) this.getData();
    },

    // async confirmStatus() {
    //   try {
    //     await PbxHttpClient.post(`/confirm-appointment/${this.itemToEdit.confirmation_token}`, {
    //       status: this.targetStatus,
    //     });
    //     const status = this.targetStatus === "canceled" ? "cancelada" : "confirmada";
    //     this.$snotify.success(`Cita ${status} con exito`, "¡Hecho!");
    //     this.tableList = this.tableList.map((el) =>
    //       el.id === this.itemToEdit.id ? { ...el, status: this.targetStatus } : el,
    //     );
    //     return true;
    //   } catch (error) {
    //     this.$snotify.error("Hubo un error actualizando la Cita", "¡Error!");
    //     console.log("error changing appointment status", error);
    //     return false;
    //   }
    // },

    getStatusColor(status) {
      switch (status) {
        case "confirmed":
          return "success";
        case "pending":
          return "light-blue";
        case "canceled":
          return "error";
      }
      return "light-blue";
    },
  },
};
</script>
